import { isNumber } from 'lodash'

export function workspaceIsPlaced(data?: {
  position?: {
    x: number
    y: number
    rotation: number
  }
}) {
  const position = data?.position
  if (!position) return false
  const { x, y, rotation } = position
  return isNumber(x) && isNumber(y) && isNumber(rotation)
}
